var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#E8F7FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_48_8676",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 33,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_48_8676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1667 40V37.3333H17.8334C17.1001 37.3333 16.4723 37.0722 15.9501 36.55C15.4279 36.0278 15.1667 35.4 15.1667 34.6667V18.6667C15.1667 17.9333 15.4279 17.3056 15.9501 16.7833C16.4723 16.2611 17.1001 16 17.8334 16H39.1667C39.9001 16 40.5279 16.2611 41.0501 16.7833C41.5723 17.3056 41.8334 17.9333 41.8334 18.6667V34.6667C41.8334 35.4 41.5723 36.0278 41.0501 36.55C40.5279 37.0722 39.9001 37.3333 39.1667 37.3333H33.8334V40H23.1667ZM17.8334 34.6667H39.1667V18.6667H17.8334V34.6667Z",
    fill: "#21ADE3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCable);
export default __webpack_public_path__ + "static/media/cable.32e1612d1c2d96f59b689559fa6fbf46.svg";
export { ForwardRef as ReactComponent };